import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./AppMenuList.styled";
export const AppMenuListItem = forwardRef((props, ref) => {
    const { children, icon, isActive, hasDivider, ...otherProps } = props;
    return (_jsxs(Styled.AppMenuListItem, { "data-testid": "AppMenuListItem", ref: ref, hasDivider: hasDivider, hasIcon: Boolean(icon), isActive: Boolean(isActive), ...otherProps, children: [icon && _jsx(Styled.IconWrapper, { children: icon }), children] }));
});
AppMenuListItem.displayName = "AppMenuListItem";
